/**
 * Логика окон: элемент по id, тип поставленного окна и размеры проёма по умолчанию.
 */
import { windowSection } from "./catalog";
import type { WindowCatalogItem } from "./types";

export const windowItemById = (id: string): WindowCatalogItem | null =>
	windowSection.items.find((item) => item.id === id) ?? null;

/** Тип поставленного окна; у старых проектов типа нет — первый элемент каталога. */
export const windowItemOf = (id: string | undefined): WindowCatalogItem =>
	(id ? windowItemById(id) : null) ?? windowSection.items[0];

/** Размеры проёма, с которыми ставится новое окно: первый элемент каталога. */
export const defaultWindowPreset = (): {
	item: string;
	width: number;
	height: number;
	sill: number;
} => {
	const item = windowSection.items[0];
	return { item: item.id, width: item.width, height: item.height, sill: item.sill };
};
